import React, { Component } from 'react';
import { Button, Switch, Icon, Modal, Form, message } from 'antd';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import ContactUs from '../../components/ContactUs';
import EnterpriseForm from '../EnterpriseForm';
import { VERSION_TICK } from '../../config/media';
import { putExchange, getExchange, postContact } from '../../common/fetch';
import { getCookie } from '../../common/utils';
import { OverviewWrapper, EnterPriseWrapper } from './style';

const ModalContent = Form.create({ name: 'EnterPriseForm' })(EnterpriseForm);

class Overview extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isCloud: false,
            isOpenForm: false,
            isVisible: false
        }
    }

    componentDidMount() {
        this.setHostingType();
    }

    setHostingType = () => {
        const { exchange } = this.props;
        this.setState({
            isCloud: exchange.type === 'Cloud'
                ? true
                : false
        })
    };

    handleToggle = (checked) => {
        this.props.handleTab(checked);
        this.setState({ isCloud: checked });
        this.submitHosting(checked ? 'Cloud' : 'DIY');
        this.props.handleUpdateTab(checked ? 'Cloud' : 'DIY')
    };

    handleForm = () => {
        this.setState({ isOpenForm: true });
    };

    handleClose = () => {
        this.setState({ isOpenForm: false });
    };

    getExchange = async () => {
        try {
            const res = await getExchange();
            const exchange = res.data.data.sort((a, b) => {
                const ad = new Date(a.updated_at);
                const bd = new Date(a.updated_at);
                if (Math.floor(ad - bd) >= 0) {
                    return a - b;
                } else {
                    return b - a;
                }
            });

            this.props.storeExchange(exchange);
        } catch (error) {
            if (error && error.data) {
                message.error(error.data.message)
            }
        }
    };

    submitHosting = async (type) => {
        const { exchange, actions } = this.props;
        try {
            const exchangeBody = {
                id: exchange.id,
                info: {
                    tech: { SERVER_TYPE: type }
                },
                type
            };
            await putExchange(exchangeBody);
            await this.getExchange();
            actions.updateTech({ SERVER_TYPE: type, type });

        } catch (error) {
            console.error(error);
            if (error.data && error.data.message) {
                message.error(error.data.message);
            } else {
                message.error('Failed to update setup configs');
            }
        }
    };

    submitEnterprise = async (formProps) => {
        const data = {
            email: getCookie('email'),
            category: 'enterprise',
            subject: 'enterprise exchange',
            description: JSON.stringify(formProps)
        };
        try {
            const res = await postContact(data);
            message.success(res.message);
            this.handleClose();
        } catch (error) {
            if (error.data && error.data.message) {
                message.error(error.data.message);
            } else {
                message.error('Fail to message');
            }
        }
    };

    handleOpenContact = () => {
        this.setState({ isVisible: true });
    };

    handleOk = (body) => {
        message.success(body);
        this.handleCancel();
    };

    handleError = (body) => {
        message.error(body);
        this.handleCancel();
    };

    handleCancel = () => {
        this.setState({ isVisible: false });
    };

    renderDescription = () => {
        const { exchange } = this.props;
        const { isCloud } = this.state;
        if (exchange.is_running) {
            return null;
        }
        if (!isCloud) {
            return (
                <div className="sub-content diy-container">
                    <div>
                        Currently your exchange is set to a on-premise self-hosted solution in order for your
                        exchange to go live you must setup and host your exchange on your own server.
                    </div>
                    <div className="margin-space">
                        <div className="sub-content content-weight margin-space">
                            <div>
                                <span className="sub-point">(1)</span>{' '}
                                <a
                                    href="https://docs.hollaex.com/get-started/installation"
                                    title="docs"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Install
                                </a>{' '} the kit following the docs
                            </div>
                            <div>
                                <span className="sub-point">(2)</span>{' '}
                                <a
                                    href="https://docs.hollaex.com/get-started/setup"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title="run"
                                >
                                    Run your exchange!
                                </a>
                            </div>
                            <div>
                                <span className="sub-point">(3)</span>{' '}
                                Setup your admin account for the exchange operator
                            </div>
                            <div>
                                <span className="sub-point">(4)</span>{' '}
                                Onboard your users
                            </div>
                        </div>
                        <div className="sub-content margin-space">
                            To get more help visit <a className="anchor" rel="noopener noreferrer" target="_blank" href="https://forum.hollaex.com">forums.</a> or <a rel="noopener noreferrer" target="_blank" href="https://www.youtube.com/watch?v=zPqvqgiMtzU">watch our video guide.</a>
                        </div>
                        {/*(!exchange.domain || !exchange.url)
                            ? <div className="button-container margin-space">
                                <Link to="/general">
                                    <Button type="primary">
                                        Connect your domain
                                    </Button>
                                </Link>
                            </div>
                            : null
                        */}
                        {/* <div className="horizontel-line margin-space" />
                        <div className="margin-space footer-container">
                            <div className="main-title">
                                Enterprise
                            </div>
                            <div className="sub-content">
                                Are you an enterprise business?
                            </div>
                            <div className="footer-content">
                                If you have an established team and/or business that can
                                manage their own liquidity then an enterprise solution might
                                be for you. To inquire about a customized enterprise solution
                                    please fill out the <Link onClick={this.handleForm}>enterprise form.</Link>
                            </div>
                        </div> */}
                    </div>
                </div>
            )
        } else {
            return (
                <div className="sub-content cloud-container">
                    <div>
                        Currently your exchange is set to cloud. Before making your exchange live you are required to settle your cloud exchange
                        {' '}<Link to={'/billing'}>hosting bill.</Link>
                    </div>
                    <div className="button-container margin-space">
                        <Button type="primary" onClick={this.props.handleLive}>
                            Go live
                        </Button>
                    </div>
                </div>
            )
        }
    }

    render() {
        const { exchange, constant, events } = this.props;
        const { isCloud } = this.state;
        const isRestarting = !!events.filter(evt => evt.type === 'restart' && (evt.status === 1 || evt.status === 0)).length;
        const isSetup = !!events.filter(evt => evt.type === 'setup' && (evt.status === 1 || evt.status === 0)).length;
        const isTerminate = !!events.filter(evt => evt.type === 'terminate' && (evt.status === 1 || evt.status === 0)).length;
        const isEventProgressing = !!events.filter(evt => (evt.status === 1 || evt.status === 0)).length;
        return (
            <OverviewWrapper>
                <div>
                    <div className="status-wrapper">
                        <div className="main-title">
                            <span>
                                Status
                            </span>
                        </div>
                        <div className="container sub-content-margin">
                            <div className="flex-content">
                                {exchange.is_running
                                    ? <img src={VERSION_TICK} alt="tick" className="tick-img" />
                                    // : <Icon
                                    //     type="minus-circle"
                                    //     theme="filled"
                                    //     style={{ fontSize: '35px', color: '#F28041' }}
                                    // />
                                    : <Icon
                                        type="exclamation-circle"
                                        theme="filled"
                                        style={{ fontSize: '35px', color: '#F83E18' }}
                                        className="exclamation-icon"
                                    />
                                }
                                <div className="content-wrapper sub-content">
                                    <div className="status-content-header">
                                        <span className="content">Status:</span>{' '}
                                        {exchange.is_running
                                            ? <span>System connected</span>
                                            : <span>
                                                System not connected
                                            </span>
                                        }
                                        <div className="underline"></div>
                                    </div>
                                    <div className="status-content">
                                        {(exchange.is_running
                                            && exchange.version
                                            && constant.kitVersion !== exchange.version)
                                            ? <div>
                                                {`New v${constant.kitVersion} upgrade available`}{' '}
                                                (<Link to="/hosting?tab=3">view</Link>)
                                            </div>
                                            : exchange.version
                                                ? (<div>
                                                    Your exchange is up-to-date.
                                                </div>)
                                                : ''
                                        }
                                        {isRestarting
                                            ? <div>
                                                Exchange restarting{' '}
                                                (<Link to="/hosting?tab=4">view</Link>)
                                            </div>
                                            : null
                                        }
                                        {isSetup
                                            ? <div>
                                                Exchange pending{' '}
                                                (<Link to="/hosting?tab=3">view</Link>)
                                            </div>
                                            : null
                                        }
                                        {isTerminate
                                            ?
                                            <div>
                                                Exchange terminating{' '}
                                                (<Link to="/hosting?tab=3">view</Link>)
                                            </div>
                                            : null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='host-wrapper'>
                    <div className="hosting-container sub-content">
                        <div className="main-title">
                            Hosting type
                        </div>
                        <div className="flex-container">
                            {!isCloud && exchange.is_running
                                ?
                                <div className="box-container right-path">
                                    <div className='content'>
                                        <div>Your exchange is live!</div>
                                    </div>
                                </div>
                                : null
                            }
                            <div className="toggle-disable-wrapper">
                                <div className={
                                    (!exchange.is_running)
                                        ? "title title-color"
                                        : "title disable-color"
                                }>
                                    Type
                                </div>
                                <span className={
                                    !isCloud && !exchange.is_running
                                        ? "toggle-menu-disable active"
                                        : "toggle-menu-disable"
                                }>
                                    On-Premise
                                </span>
                                <span className="switch-container">
                                    <Switch
                                        checked={isCloud}
                                        disabled={
                                            (exchange.is_running || isEventProgressing)
                                                ? true
                                                : false
                                        }
                                        onChange={this.handleToggle}
                                    />
                                </span>
                                <span className={
                                    isCloud && !exchange.is_running
                                        ? "toggle-menu-disable active"
                                        : "toggle-menu-disable"
                                }
                                >
                                    Cloud
                                </span>
                            </div>
                            {(!exchange.is_running)
                                ? (<div className="toggle-description">
                                    You can setup how and where your exchange is hosted. This could be on Holla Cloud or it could be on your server which is an on-premise exchange.
                                </div>)
                                : null
                            }
                            {isCloud && exchange.is_running
                                ?
                                <div className="box-container left-path">
                                    <div className='content'>
                                        <div>Your exchange is live!</div>
                                        <div><span className="link" onClick={this.handleOpenContact}>Contact us</span> to adjust hosting</div>
                                    </div>
                                </div>
                                : null
                            }
                        </div>
                    </div>
                    {this.renderDescription()}
                    </div>
                    <Modal
                        visible={this.state.isOpenForm}
                        footer={null}
                        width={'35rem'}
                        onCancel={this.handleClose}
                    >
                        {this.state.isOpenForm
                            ? <EnterPriseWrapper>
                                <ModalContent
                                    onSubmitEnterprise={this.submitEnterprise}
                                />
                            </EnterPriseWrapper>
                            : null
                        }
                    </Modal>
                    <ContactUs
                        visible={this.state.isVisible}
                        defaultType="Other"
                        handleOk={this.handleOk}
                        handleError={this.handleError}
                        handleCancel={this.handleCancel}
                    />
                </div>
            </OverviewWrapper>
        )
    }
}

const mapStateToProps = (state) => ({
    events: state.constant.events
});

export default connect(mapStateToProps)(Overview);